<template>
  <div>
    <b-dropdown>
      <button
        class="flex items-center px-3 py-1 space-x-3 text-sm rounded shadow-sc-button focus:outline-none"
        slot="trigger"
      >
        <p class="text-secondary">
          Exportar
        </p>
        <img
          :src="require('@assets/images/chevron-down-outline.svg')"
          alt="flecha para abajo"
        >
      </button>
      <b-dropdown-item
        v-for="(format, index) in ['csv', 'xlsx']"
        :key="index"
        class="px-0"
      >
        <div
          class="flex space-x-2"
          :loading="!!pollingInterval"
        >
          <button
            class="w-full pl-3 text-left"
            @click="generateDownload(format)"
          >
            <p class="inline text-sm text-primary">
              {{ format.toUpperCase() }}
            </p>
            <img
              :src="require('@assets/images/export.svg')"
              alt="exportar"
              class="inline-block w-3"
            >
          </button>
        </div>
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import DownloadApi from '@/src/api/downloads';

const DOWNLOAD_POLLING_INTERVAL = 3000;

export default {
  data() {
    return {
      downloadId: null,
      downloadType: null,
      pollingInterval: null,
      error: null,
    };
  },
  computed: {
    currentFilters() {
      return this.$store.getters.currentFilters;
    },
    entityId() {
      return this.$store.state.entities.entityId;
    },
  },
  methods: {
    noticeDownload() {
      this.$buefy.toast.open('Descarga iniciada, puede tomar unos segundos');
    },
    noticeResult() {
      if (this.error) {
        this.$buefy.toast.open({
          message: 'Error al descargar la cartola',
          type: 'is-danger',
        });
      } else {
        this.$buefy.toast.open({
          message: 'Cartola descargada con éxito',
          type: 'is-success',
        });
      }
    },
    async generateDownload(format) {
      this.error = false;
      try {
        this.downloadType = format;
        this.noticeDownload();
        const response = await DownloadApi.createDownload({
          ...this.currentFilters,
          entityId: this.entityId,
          downloadType: format,
        });
        const { id } = response.data[this.downloadType];
        if (id) {
          this.downloadId = id;
          this.startPolling();
        }
      } catch (error) {
        this.error = true;
      }
    },
    startPolling() {
      this.getDownloadStatus();
      this.pollingInterval = setInterval(this.getDownloadStatus, DOWNLOAD_POLLING_INTERVAL);
    },
    async getDownloadStatus() {
      if (!this.downloadId) return;

      const response = await DownloadApi.getDownload(this.downloadId, { entityId: this.entityId });
      const { error, readyForDownload, url } = response.data[this.downloadType];

      if (!readyForDownload) return;

      this.error = error;
      if (url) {
        window.location.href = url;
        this.downloadId = null;
      }
      this.stopPolling();
    },
    stopPolling() {
      this.noticeResult();
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
    },
  },
  beforeDestroy() {
    this.stopPolling();
  },
};
</script>
